const heading2 = [
  "M1.78 12.82v-3.9H6v3.9h1.78V3.38H6v3.88H1.78V3.38H0v9.44h1.78zM16 12.8v-1.67h-3.84l2.1-1.85C15.4 8.3 16 7.78 16 6.38c0-.76-.22-1.55-.73-2.12a3.3 3.3 0 0 0-2.49-1.08c-.87 0-1.7.2-2.32.75A2.98 2.98 0 0 0 9.4 6.34h1.83a1.48 1.48 0 0 1 .46-1.09 1.48 1.48 0 0 1 1.05-.39c.46 0 .83.16 1.1.52.23.27.32.64.32.98 0 .4-.22.86-.8 1.39l-3.96 3.5v1.57H16z"
];
export {
  heading2
};
//# sourceMappingURL=heading2.js.map
